module.exports = __webpack_public_path__ + "static/img/zcr.868fa2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/zcr.png
// module id = WAmM
// module chunks = 1